import React from 'react';
import TopBar from '../../components/layout/TopBar';
import BrandMark from '../../components/layout/BrandMark';

export default function AuthLayout({ title, subtitle, children, footer, onBack }) {
  return (
    <div className="page page--white auth">
      <TopBar onBack={onBack} />
      <div className="auth__body">
        <BrandMark size="lg" />
        <h1 className="auth__title">{title}</h1>
        {subtitle && <p className="auth__subtitle">{subtitle}</p>}
        <div className="auth__content">{children}</div>
      </div>
      {footer && <div className="auth__footer">{footer}</div>}
    </div>
  );
}
